import {addBreadcrumb, Breadcrumb} from '@sentry/browser';

export default function attemptCaptureBreadcrumb(crumb: Breadcrumb): void {
  try {
    addBreadcrumb(crumb);
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Unable to capture Sentry breadcrumb:', crumb, e);
  }
}
